import { Route } from "react-router-dom";
import SingleStudent from "@pages/students/single-student";
import StudentsAnalytics from "@pages/students/student-analytics";

export const studentRoutes = [
  <Route key="students" path="/students" element={<StudentsAnalytics />} />,
  <Route
    key="single-student"
    path="/students/:id"
    element={<SingleStudent />}
  />,
];
